<template>
  <div class="setting_main_contents" id="entry-main-content" v-on:scroll="scrollMenuItem">
    <div :class="{'overlay_setting':isLoadingData}">
      <i :class="{'loadding_setting': isLoadingData}"></i>
    </div>
    <div class="setting_heading">
      <h1 class="setting_heading_title">
        {{ entrySettingProperty.TAB_HEADER }}
      </h1>
      <p class="setting_heading_explain">
        {{ entrySettingProperty.SUB_HEADER }}
      </p>
      <button class="setting_btn_outline" @click.prevent="openModalPreview">
        {{ entrySettingProperty.PREVIEW_BUTTON }}
      </button>
      <PreviewDisplay
          v-show="isVisibleModalPreview"
          :categories="categories"
          :colors="colors"
          :privacy="policy"
          :button="button"
          :message="message"
          :masters="masters"
          :entryPageName="entryPageName"
          :entryOverview="entryOverview"
          @close="closeModalPreview"
      />
    </div>
    <div class="setting_tab">
      <div class="setting_tab_nav">
        <ul class="setting_tab_nav_list">
          <li id="t1" class="setting_tab_nav_item is_active" @click.prevent="changeNavTab(SCREEN_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.SCREEN_TAB_TITLE }}
            </span>
          </li>
          <li id="t2" class="setting_tab_nav_item" @click.prevent="changeNavTab(BUTTON_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.BUTTON_TAB_TITLE }}
            </span>
          </li>
          <li id="t3" class="setting_tab_nav_item" @click.prevent="changeNavTab(MESSAGE_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.MESSAGE_TAB_TITLE }}
            </span>
          </li>
          <li id="t4" class="setting_tab_nav_item" @click.prevent="changeNavTab(POLICY_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.POLICY_TAB_TITLE }}
            </span>
          </li>
          <li id="t5" class="setting_tab_nav_item" @click.prevent="changeNavTab(MAIL_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.MAIL_TAB_TITLE }}
            </span>
          </li>
          <li id="t6" class="setting_tab_nav_item" @click.prevent="changeNavTab(COLOR_THEME_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.COLOR_THEME_TAB_TITLE }}
            </span>
          </li>
          <li id="t7" class="setting_tab_nav_item" @click.prevent="changeNavTab(ADVANCE_SETTING_TAB)">
            <span class="setting_tab_nav_text">
              {{ entrySettingProperty.ADVANCE_SETTING_TAB_TITLE }}
            </span>
          </li>
        </ul>
      </div>
      <div v-show="navTab === SCREEN_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <ScreenTab
              :groupName="groupName"
              :categories="categories"
              :property="property"
              :resourceFields="resourceFields"
              :candidateCategories="candidateCategories"
              :userId="log.info.userId"
              :navTab="navTab"
              @categoriesWasEdited="updateCategory"
              @getResourceFields="getResourceFields(property, $event)"
              @updatedProperty="updatedProperty"
              @updateResourceField="updateResourceField"
              @refreshResourceList="refreshResourceList($event)"
              @createLogger="createLogger($event)"
              @sendLogger="sendLogger"
              @updateEditingStatus="updateEditingStatus"
          />
        </div>
      </div>
      <div v-show="navTab === BUTTON_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <ButtonTab
              :button="button"
              :buttonError="buttonError"
              @updateBtnError="updateBtnError"
          />
        </div>
      </div>
      <div v-show="navTab === MESSAGE_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <MessageTab
              :message="message"
              :messageError="messageError"
              @updateMsgError="updateMsgError"
          />
        </div>
      </div>
      <div v-show="navTab === POLICY_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <PrivacyPolicyTab
              :policy="policy"
              :policyError="policyError"
              @updatePolicyError="updatePolicyError"
          />
        </div>
      </div>
      <div v-show="navTab === MAIL_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <MailTab
              :mail="mail"
              :mailError="mailError"
              :humanResourceFields="resourceFields"
              :humanCandidateCategories="candidateCategories"
              :dispatchJobResourceFields="dispatchJobResourceFields"
              :dispatchJobCategories="dispatchJobCategories"
              :jobResourceFields="jobResourceFields"
              :jobCategories="jobCategories"
              :propertyDispatchJobResource="propertyDispatchJob"
              :propertyJobResource="propertyJob"
              :propertyHumanResource="propertySearchInMailTab"
              :mailReplaces="mailReplaces"
              :mailReplacesJob="mailReplacesJob"
              :mailReplacesDispatch="mailReplacesDispatch"
              :userId="log.info.userId"
              :groupName="groupName"
              :users="users"
              :hp_renkei_job="hp_renkei_job"
              :is_plan_dispatch_basic="is_plan_dispatch_basic"
              @updateMailError="updateMailError"
              @getHumanResourceFields="getResourceFields(propertySearchInMailTab, $event)"
              @updatedPropertyHumanResource="updatedPropertySearchHumanResourceMailTab"
              @updateHumanResourceField="updateResourceField"
              @refreshHumanResourceList="refreshResourceListInMailTab($event)"
              @getDispatchJobResourceFields="getDispatchJobResourceFields(propertyDispatchJob, $event)"
              @updatedPropertyDispatchJobResource="updatedPropertyDispatchJob"
              @updateDispatchJobResourceField="updateDispatchJobResourceField"
              @refreshDispatchJobResourceList="refreshDispatchJobResourceList($event)"
              @getJobResourceFields="getJobResourceFields(propertyJob, $event)"
              @updatedPropertyJobResource="updatedPropertyJob"
              @updateJobResourceField="updateJobResourceField"
              @refreshJobResourceList="refreshJobResourceList($event)"
              @updatedReplaceMail="updatedReplaceMail"
              @updatedReplaceMailJob="updatedReplaceMailJob"
              @updatedReplaceMailDispatch="updatedReplaceMailDispatch"
              @createLogger="createLogger($event)"
              @sendLogger="sendLogger"
              @updateSrollMenu="scrollMenuItem"
          />
        </div>
      </div>
      <div v-show="navTab === COLOR_THEME_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <CustomizeMode
              :customizeMode="customizeMode"
              :categories="categories"
              :colors="colors"
              :privacy="policy"
              :button="button"
              :message="message"
              :masters="masters"
              :entryPageName="entryPageName"
              :entryOverview="entryOverview"
              :selectedTheme="selectedTheme"
              :customizeSettings="customizeSettings"
              :groupName="groupName"
              :userId="log.info.userId"
              :token="token"
              @updateCustomizeColors="updateColors"
              @updatedSelectedTheme="updatedSelectedTheme"
              @refreshCustomizeSetting="refreshCustomizeSettings($event)"
              @createLogger="createLogger($event)"
              @sendLogger="sendLogger"
          />
        </div>
      </div>
      <div v-show="navTab === ADVANCE_SETTING_TAB" class="setting_tab_content">
        <div class="setting_tab_content_panel is_active">
          <AdvanceSettingTab
              :masterStepStates="masterStepStates"
              :masterMedia="masterMedia"
              :users="users"
              :displaySetting="displaySetting"
              :hp_renkei_job="hp_renkei_job"
              :hp_renkei_entry="hp_renkei_entry"
          />
        </div>
      </div>
    </div>
    <div class="setting_footer" id="setting_footer">
      <button class="setting_btn_outline" @click="cancelChangeEntryScreenSettings()">
        {{ entrySettingProperty.CANCEL_BUTTON }}
      </button>
      <button class="setting_btn_primary" @click="saveData()"
              :class="{'setting_btn_disabled': isDisableSaveBtn || editingStatus}">
        {{ entrySettingProperty.SAVE_BUTTON }}
      </button>
      <div class="setting_footer_balloon" v-if="unSavedData">
        {{ entrySettingProperty.SAVE_CHANGE_DATA }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ScreenTab from "./EntryScreenSettingsComponents/ScreenTab";
import ButtonTab from "./EntryScreenSettingsComponents/ButtonTab";
import PrivacyPolicyTab from "./EntryScreenSettingsComponents/PrivacyPolicyTab";
import MessageTab from "./EntryScreenSettingsComponents/MessageTab.vue";
import MailTab from "./EntryScreenSettingsComponents/MailTab";
import CustomizeMode from "../CommonSettings/EntryScreenSettingsComponents/CustomizeMode";
import AdvanceSettingTab from "../CommonSettings/EntryScreenSettingsComponents/AdvanceSettingTab";
import VueToast from "vue-toast-notification";
import formSettingService from "../../services/FormSettingService";
import PreviewDisplay from "../CommonSettings/EntryScreenSettingsComponents/PreviewDisplay";
import entrySettingService from "../../services/EntrySettingService";
import masterSettingService from "../../services/MasterSettingsService";
import entrySettingNotificationProperty from "../../properties/entry_screen/notifications.json";
import entrySettingProperty from "../../properties/entry_screen/entry_screen.json";
import jobSettingService from "../../services/JobSettingService";
import * as StrUtil from "../../util/StringUtil";
import generalService from "../../services/GeneralService";
import * as generalLabels from "../../properties/general_page/generalpage-labels.json";
import * as generalMessages from "../../properties/general_page/generalpage.json";
import * as customizeModalLabels from "../../properties/entry_screen/customize_tab/popup-customize/popup-customize-labels.json";
import Utils from "../../Utils";
Vue.use(VueToast);

const entryFormType = 0;
const KEY_SETTING_DISPLAYS = ["candidate_job_step_states","media"];
const JOB_DETAIL_FORM_TYPE = 2;
const DISPATCH_JOB_DETAIL_FORM_TYPE = 6;

const SCREEN_TAB = 1;
const BUTTON_TAB = 2;
const MESSAGE_TAB = 3;
const POLICY_TAB = 4;
const MAIL_TAB = 5;
const COLOR_THEME_TAB = 6;
const ADVANCE_SETTING_TAB = 7;

const AUTO_MAIL_REPLY = 0;
const AUTO_MAIL_REPLY_JOB = 2;
const AUTO_MAIL_REPLY_DISPATCH = 3;
const NOTIFICATION_MAIL = 1;
const START_PAGE_TITLE = generalLabels.START_TITLE_PAGE + " > " + entrySettingProperty.ENTRY_SETTING_PAGE_TITLE + " > ";

const ITEM_JOB = 5;
const ITEM_DISPATCH_JOB = 7;
const ITEM_ENTRY = 6;

export default {
  name: "EntryScreenSettings",
  components: {
    ScreenTab,
    ButtonTab,
    PrivacyPolicyTab,
    MessageTab,
    MailTab,
    CustomizeMode,
    PreviewDisplay,
    AdvanceSettingTab
  },
  props: [
    "entryPageName",
    "entryOverview",
    "groupName",
    "unSavedData",
    "userId",
    "token",
    "hp_renkei_job",
    "hp_renkei_entry",
    "is_plan_dispatch_basic"
  ],
  data: function () {
    return {
      isVisibleModalPreview: false,
      categories: [],
      buttonError: false,
      button: {
        entryButton: "",
        confirmButton: "",
        returnButton: ""
      },
      buttonSettings: [],
      messageError: false,
      message: {
        titleEntry: "",
        titleConfirm: "",
        titleCompletion: "",
        messageTitleCompletion: "",
        messageConfirm: "",
        messageBodyCompletion: "",
        messageError: ""
      },
      messageSettings: [],
      policyError: false,
      policy: {
        content: "",
        url: "",
        textLink: "",
        isEnabledPolicy: false,
        isEnabledUrl: false
      },
      policySettings: [],
      mailError: false,
      mail: {
        emailTitle: "",
        errorEmailTitle: "",
        emailBody: "",
        emailBodyJob: "",
        emailBodyDispatch: "",
        emailSubject: "",
        user: {
          id: 0,
          email: "",
          isDeleted: false
        },
        emailAccounts: [
          {
            emailAccount: "",
          },
        ]
      },
      mailSettings: [],
      customizeMode: {},
      colors: {
        themeName: "Default",
        borderColor: "#989090",
        highlightText: "#100F0F",
        keyColor: "#CFC9C9",
        linkText: "#3090d9",
        mainButtonText: "#FFF",
        mainButton: "#F36A07",
        pageBackground: "#FFFFFF",
        pageText: "#0D0D0D",
        requiredLabel: "#FF0000",
        requiredLabelText: "#FFFFFF",
        subButton: "#F8F7F7",
        subButtonText: "#000000",
        subColor: "#E7E4E4"
      },
      masters: [],
      formSetting: {
        formColorTheme: 0,
        categorySetting: [],
        buttonSetting: [],
        messageSetting: [],
        policySetting: [],
        mailSetting: [],
        customizeSetting: {}
      },
      customizeSettings: [],
      selectedTheme: -1,
      itemResourcesUsed: [],
      itemResourceUsedInMailTabs: [],
      itemResourceUsedInMailTabsJob: [],
      itemResourceUsedInMailTabsDispatch: [],
      resourceFields: [],
      candidateCategories: [],
      property: "",
      propertySearchInMailTab: "",
      idItemsDeletedMainSystems: [],
      itemsDeletedMainSystem: [],
      isChangeColor: false,
      entrySettingProperty: entrySettingProperty,
      navTab: SCREEN_TAB,
      careersResourceId: -1,
      educationsResourceId: -1,
      keyMasters: [],
      masterStepStates: [],
      masterMedia: [],
      users: [],
      userIds: [],
      displaySetting: {
        progressStep: 0,
        inHouseHP: 0,
        manager: 0,
        print: false
      },
      dispatchJobResourceFields: [],
      dispatchJobCategories: [],
      jobResourceFields: [],
      jobCategories: [],
      propertyDispatchJob: "",
      propertyJob: "",
      mailReplaces: [
        {
          keyReplace: "",
          itemReplace: "",
          itemReplaces: []
        }
      ],
      mailReplacesJob: [
        {
          keyReplace: "",
          itemReplace: "",
          itemReplaces: []
        }
      ],
      mailReplacesDispatch: [
        {
          keyReplace: "",
          itemReplace: "",
          itemReplaces: []
        }
      ],
      missingKeyReplaces: [],
      missingKeyReplacesJob: [],
      missingKeyReplacesDispatch: [],
      jobDetailForm: [],
      dispatchJobDetailForm: [],
      missingItemRequires: [],
      log: {
        info: {}
      },
      isDisableSaveBtn: false,
      isLoadingData: true,
      SCREEN_TAB: SCREEN_TAB,
      BUTTON_TAB: BUTTON_TAB,
      MESSAGE_TAB: MESSAGE_TAB,
      POLICY_TAB: POLICY_TAB,
      MAIL_TAB: MAIL_TAB,
      COLOR_THEME_TAB: COLOR_THEME_TAB,
      ADVANCE_SETTING_TAB: ADVANCE_SETTING_TAB,
      editingStatus: false
    };
  },
  watch: {
    navTab() {
      this.checkDisableSaveBtn();
    },
    buttonError() {
      this.checkDisableSaveBtn();
    },
    mailError() {
      this.checkDisableSaveBtn();
    },
    messageError() {
      this.checkDisableSaveBtn();
    },
    policyError() {
      this.checkDisableSaveBtn();
    },
  },
  async created() {
    document.title = START_PAGE_TITLE + entrySettingProperty.SCREEN_TAB_TITLE;
    this.log.info.userId = this.userId;
    await this.createLogger("Load data menu " + generalLabels.SECOND_TAB);
    await this.getCustomizeTheme(entryFormType, this.log.hash);
    await this.getResourceFields("", this.log.hash);
    await this.getCandidateCategories(this.log.hash);
    if (this.hp_renkei_job === 1) {
      await this.getDetailFormData(JOB_DETAIL_FORM_TYPE, this.log.hash);
      await this.getJobResourceFields("", this.log.hash);
      await this.getJobCategories(this.log.hash);
      if (this.is_plan_dispatch_basic === 1) {
        await this.getDispatchDetailFormData(DISPATCH_JOB_DETAIL_FORM_TYPE, this.log.hash);
        await this.getDispatchJobResourceFields("", this.log.hash);
        await this.getDispatchJobCategories(this.log.hash);
      }
    }
    await this.getEntryFormSetting(entryFormType, this.log.hash);
    this.isLoadingData = false;
  },
  methods: {
    updatedReplaceMail(mailReplaces) {
      this.mailReplaces = mailReplaces;
    },

    updatedReplaceMailJob(mailReplacesJob) {
      this.mailReplacesJob = mailReplacesJob;
    },

    updatedReplaceMailDispatch(mailReplacesDispatch) {
      this.mailReplacesDispatch = mailReplacesDispatch;
    },

    checkDisableSaveBtn() {
      this.isDisableSaveBtn =
          (this.navTab === BUTTON_TAB && this.buttonError) ||
          (this.navTab === MESSAGE_TAB && this.messageError) ||
          (this.navTab === POLICY_TAB && this.policyError) ||
          (this.navTab === MAIL_TAB && this.mailError);
    },

    async changeNavTab(tab) {
      if (this.navTab === tab) {
        return;
      }

      if (this.navTab === MAIL_TAB && this.keyReplaceInMailBodyNotMathWithSetting()) {
        this.alertMissingKeyReplace();
        return;
      }

      if (this.navTab === SCREEN_TAB && this.itemRequiredIsNotSetting()) {
        alert(entrySettingNotificationProperty.NOTIFY_ITEM_REQUIRED_NOT_SETTING + "\n " + this.missingItemRequires.join("\n "));
        return;
      }

      switch (tab) {
        case SCREEN_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.SCREEN_TAB_TITLE;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.SCREEN_TAB_TITLE);
          break;
        case BUTTON_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.BUTTON_TAB_TITLE;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.BUTTON_TAB_TITLE);
          break;
        case MESSAGE_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.MESSAGE_TAB_TITLE;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.MESSAGE_TAB_TITLE);
          break;
        case POLICY_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.POLICY_TAB_TITLE;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.POLICY_TAB_TITLE);
          break;
        case MAIL_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.MAIL_TAB_TITLE;
          this.isLoadingData = true;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.MAIL_TAB_TITLE);
          await this.getUsers(this.log.hash, tab);
          this.refreshResourceField();
          this.refreshJobResourceField();
          this.refreshDispatchJobResourceField();
          this.refreshItemResourceInMailTab();
          this.refreshItemResourceInMailTabJob();
          this.refreshItemResourceInMailTabDispatch();
          this.scrollMenuItem();
          this.isLoadingData = false;
          break;
        case COLOR_THEME_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.COLOR_THEME_TAB_TITLE;
          this.isLoadingData = true;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.COLOR_THEME_TAB_TITLE);
          await this.getKeyMasterUsed();
          if (this.keyMasters.length > 0) {
            await this.getMastersByCategorySetting(this.keyMasters, this.log.hash);
          }

          this.isLoadingData = false;
          break;
        case ADVANCE_SETTING_TAB:
          document.title = START_PAGE_TITLE + entrySettingProperty.ADVANCE_SETTING_TAB_TITLE;
          this.isLoadingData = true;
          await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click tab " + entrySettingProperty.ADVANCE_SETTING_TAB_TITLE);
          await this.getMastersSettingDisplay(KEY_SETTING_DISPLAYS, this.log.hash);
          await this.getUsers(this.log.hash, tab);
          this.isLoadingData = false;
          break;
      }

      document.getElementById("t" + this.navTab).classList.remove("is_active");
      this.navTab = tab;
      document.getElementById("t" + tab).classList.add("is_active");
      this.editingStatus = false;
    },

    async getMastersSettingDisplay(keys, hash) {
      await masterSettingService.getMastersByCategorySetting(keys, hash).then(response => {
            if (response && response.data && response.data) {
              if(response.data.candidate_job_step_states && response.data.candidate_job_step_states.items){
                this.masterStepStates = response.data.candidate_job_step_states.items;
                this.masterStepStates.unshift({
                  choiceDisplayName: entrySettingProperty.OPTION_SELECT_DEFAULT,
                  choiceId: 0,
                  show: true,
                });
              }
              if(response.data.media && response.data.media.items){
                this.masterMedia = response.data.media.items;
                this.masterMedia.unshift({
                  choiceDisplayName: entrySettingProperty.OPTION_SELECT_DEFAULT,
                  choiceId: 0,
                  show: true,
                });
              }
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
            Vue.$toast.clear();
            Vue.$toast.error(
                entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          });
    },

    async getUsers(hash, tab) {
      await entrySettingService.getUsers(hash, this.token).then(response => {
            if (response && response.data != null) {
              this.userIds = response.data;
              this.getUserDetails(this.userIds, hash, tab);
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
            Vue.$toast.clear();
            Vue.$toast.error(
                entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          });
    },

    async getUserDetails(ids, hash, tab) {
      await entrySettingService.getUserDetails(ids, hash, this.token)
          .then(response => {
            if (response && response.data != null) {
              this.users = response.data;
              this.users.sort(function(a, b) {
                return a.id - b.id;
              });
              this.users.map(user => {
                const newPropsObj = {
                  isDeleted: false
                };
                Object.assign(user, newPropsObj);
              });
              this.users.unshift({
                display_name: entrySettingProperty.OPTION_SELECT_DEFAULT,
                id: 0,
                isDeleted: false
              });
              if (this.users.some(user => user.id === this.mail.user.id)) {
                return;
              }

              let userDeleted = {};
              userDeleted.id = this.mail.user.id;
              userDeleted.email = this.mail.user.email;
              userDeleted.isDeleted = true;
              this.users.push(userDeleted);
              this.mail.user.isDeleted = true;
              if (tab === MAIL_TAB) alert(entrySettingNotificationProperty.USER_DELETED_IN_MAIL_TAB);
              this.updateTimeDeletedUser(userDeleted, hash);
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
            Vue.$toast.clear();
            Vue.$toast.error(
                entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          });
    },

    async updateTimeDeletedUser(userDeleted, hash) {
      let mailSenderSetting = this.mailSettings.filter(mail => mail && mail.emailType === 0);
      if (!mailSenderSetting || mailSenderSetting.length <= 0) {
        return;
      }

      let userMailSetting = {
        formSetting: {
          id: this.formSetting.id ? this.formSetting.id : null
        },
        emailAccounts: [{
          id: mailSenderSetting[0].id,
          emailAccount: userDeleted.email,
          userId: userDeleted.id,
          isUserDeleted: userDeleted.isDeleted
        }]
      };
      await formSettingService.updateTimeUserMailSettingDeleted(userMailSetting, hash, this.token).catch(e => {
        console.log(e);
      })
    },


    getKeyMasterUsed() {
      if (this.categories.length <= 0) {
        return;
      }

      this.keyMasters = [];
      this.categories.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category => {
            category.item.filter(item => item.resourceField && item.resourceField.length > 0 && !item.itemDeleted).forEach(item => {
                  item.resourceField.filter(resource => !resource.itemResourceDeleted && resource.master_name).forEach(resource => {
                        if (!this.keyMasters.some((key) => key === resource.master_name)) {
                          this.keyMasters.push(resource.master_name);
                        }
                      });
                });
          });
    },

    async getMastersByCategorySetting(keys, hash) {
      await masterSettingService.getMastersByCategorySetting(keys, hash).then(response => {
            if (response && response.data != null) {
              this.masters = response.data;
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
            Vue.$toast.clear();
            Vue.$toast.error(
                entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          });
    },

    updatedProperty(val) {
      this.property = val;
    },

    updatedPropertySearchHumanResourceMailTab(value) {
      this.propertySearchInMailTab = value;
    },

    updatedPropertyJob(val) {
      this.propertyJob = val;
    },

    updatedPropertyDispatchJob(val) {
      this.propertyDispatchJob = val;
    },

    updateResourceField(resources) {
      this.resourceFields = resources;
    },

    updateJobResourceField(jobResourceFields) {
      this.jobResourceFields = jobResourceFields;
    },

    updateDispatchJobResourceField(jobResourceFields) {
      this.dispatchJobResourceFields = jobResourceFields;
    },

    async getResourceFields(property, hash) {
      property = StrUtil.toHalfWidth(property);
      let searchDto = {};
      searchDto.keyWord = property;
      await entrySettingService.getResourceField(searchDto, hash, this.token).then(response => {
            if (response && response.data != null) {
              this.resourceFields = [];
              Object.keys(response.data).map(key => {
                if (response.data[key].property_category_name === undefined) {
                  Object.keys(response.data[key]).map(subKey => {
                    if (["dispatch_insurance", "dispatch_basic"].includes(key)) {
                      response.data[key][subKey].name = key + "." + response.data[key][subKey].name;
                    }

                    this.resourceFields.push(response.data[key][subKey]);
                  });
                } else {
                  this.resourceFields.push(response.data[key]);
                }
              });

            this.refreshResourceField();
            this.refreshItemResourceInMailTab();
            this.refreshItemResourceInMailTabJob();
            this.refreshItemResourceInMailTabDispatch();
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
            Vue.$toast.clear();
            Vue.$toast.error(
                entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          });
    },

    refreshResourceField() {
      this.getItemResourcesUsedInScreenTab();
      if (this.itemResourcesUsed.length <= 0) {
        return;
      }

      this.itemResourcesUsed.forEach(itemMasterUsed => {
        this.resourceFields.forEach(itemMaster => {
          let nameResourceEducationOrCareer = "";
          if (itemMasterUsed.name && (itemMasterUsed.name.includes("careers.") || itemMasterUsed.name.includes("educations."))) {
            nameResourceEducationOrCareer = itemMasterUsed.name.substring(itemMasterUsed.name.indexOf(".") + 1, itemMasterUsed.name.length);
          }

          if ((itemMasterUsed.name === itemMaster.name || itemMaster.name === nameResourceEducationOrCareer) && ((itemMasterUsed.property_category_name === itemMaster.property_category_name && itemMasterUsed.property_category_name) || !itemMasterUsed.property_category_name)) {
            itemMaster.isUsed = true;
          }

          if (itemMaster.careers) {
            this.refreshCareerAndEducationItem(itemMaster.careers, itemMasterUsed);
          }

          if (itemMaster.educations) {
            this.refreshCareerAndEducationItem(itemMaster.educations, itemMasterUsed);
          }
        });
      });
    },

    refreshCareerAndEducationItem(items, itemMasterUsed) {
      for (let item of Object.entries(items)) {
        if (item.display_name === itemMasterUsed.display_name) {
          item.isUsed = true;
        }
      }
    },

    refreshItemResourceInMailTab() {
      this.getItemResourcesUsedInMailTab(entryFormType);
      if (this.itemResourceUsedInMailTabs.length <= 0) {
        return;
      }

      this.itemResourceUsedInMailTabs.forEach(itemUsed => {
        this.resourceFields.filter(item => item && item.isUsed).forEach(item => {
              let nameResourceEducationOrCareer = "";
              if (itemUsed.name && (itemUsed.name.includes("careers.") || itemUsed.name.includes("educations."))) {
                nameResourceEducationOrCareer = itemUsed.name.substring(itemUsed.name.indexOf(".") + 1, itemUsed.name.length);
              }

              if (itemUsed.name === item.name || item.name === nameResourceEducationOrCareer) {
                item.isUsedMailTab = true;
              }
            });
      });
    },

    refreshItemResourceInMailTabJob() {
      this.getItemResourcesUsedInMailTab(JOB_DETAIL_FORM_TYPE);
      if (this.itemResourceUsedInMailTabsJob.length <= 0) {
        return;
      }

      this.itemResourceUsedInMailTabsJob.forEach(itemUsed => {
        this.resourceFields.filter(item => item && item.isUsed).forEach(item => {
          let nameResourceEducationOrCareer = "";
          if (itemUsed.name && (itemUsed.name.includes("careers.") || itemUsed.name.includes("educations."))) {
            nameResourceEducationOrCareer = itemUsed.name.substring(itemUsed.name.indexOf(".") + 1, itemUsed.name.length);
          }

          if (itemUsed.name === item.name || item.name === nameResourceEducationOrCareer) {
            item.isUsedMailTab = true;
          }
        });
      });

      this.itemResourceUsedInMailTabsJob.forEach((itemUsed) => {
        this.jobResourceFields.filter(item => item && item.isUsed).forEach(item => {
          if (itemUsed.name === item.name) {
            item.isUsedMailTab = true;
          }
        });
      });
    },

    refreshItemResourceInMailTabDispatch() {
      this.getItemResourcesUsedInMailTab(DISPATCH_JOB_DETAIL_FORM_TYPE);
      if (this.itemResourceUsedInMailTabsDispatch.length <= 0) {
        return;
      }

      this.itemResourceUsedInMailTabsDispatch.forEach(itemUsed => {
        this.resourceFields.filter(item => item && item.isUsed).forEach(item => {
          let nameResourceEducationOrCareer = "";
          if (itemUsed.name && (itemUsed.name.includes("careers.") || itemUsed.name.includes("educations."))) {
            nameResourceEducationOrCareer = itemUsed.name.substring(itemUsed.name.indexOf(".") + 1, itemUsed.name.length);
          }

          if (itemUsed.name === item.name || item.name === nameResourceEducationOrCareer) {
            item.isUsedMailTab = true;
          }
        });
      });

      this.itemResourceUsedInMailTabsDispatch.forEach(itemUsed => {
        this.dispatchJobResourceFields.filter(item => item && item.isUsed).forEach(item => {
          if (itemUsed.name === item.name) {
            item.isUsedMailTab = true;
          }
        });
      });
    },

    getItemResourcesUsedInMailTab(type) {
      switch (type) {
        case entryFormType:
          this.itemResourceUsedInMailTabs = [];
          this.mailReplaces.filter(mailReplace => mailReplace && mailReplace.itemReplaces && mailReplace.itemReplaces.length > 0).forEach(mailReplace => {
            mailReplace.itemReplaces.filter(item => item && item.name).forEach(item => {
              let resourceEduOrCareer = this.getOriginNameResource(item);
              if (this.itemResourceUsedInMailTabs.some(itemResourceUsed => itemResourceUsed.name === item.name || itemResourceUsed.name === resourceEduOrCareer)) {
                return;
              }

              this.itemResourceUsedInMailTabs.push(item);
            });
          });
          break;
        case JOB_DETAIL_FORM_TYPE:
          this.itemResourceUsedInMailTabsJob = [];
          this.mailReplacesJob.filter(mailReplace => mailReplace && mailReplace.itemReplaces && mailReplace.itemReplaces.length > 0).forEach(mailReplace => {
            mailReplace.itemReplaces.filter(item => item && item.name).forEach(item => {
              let resourceEduOrCareer = this.getOriginNameResource(item);
              if (this.itemResourceUsedInMailTabsJob.some(itemResourceUsed => itemResourceUsed.name === item.name || itemResourceUsed.name === resourceEduOrCareer)) {
                return;
              }

              this.itemResourceUsedInMailTabsJob.push(item);
            });
          });
          break;
        case DISPATCH_JOB_DETAIL_FORM_TYPE:
          this.itemResourceUsedInMailTabsDispatch = [];
          this.mailReplacesDispatch.filter(mailReplace => mailReplace && mailReplace.itemReplaces && mailReplace.itemReplaces.length > 0).forEach(mailReplace => {
            mailReplace.itemReplaces.filter(item => item && item.name).forEach(item => {
              let resourceEduOrCareer = this.getOriginNameResource(item);
              if (this.itemResourceUsedInMailTabsDispatch.some(itemResourceUsed => itemResourceUsed.name === item.name || itemResourceUsed.name === resourceEduOrCareer)) {
                return;
              }

              this.itemResourceUsedInMailTabsDispatch.push(item);
            });
          });
          break;
      }
    },

    getItemResourcesUsedInScreenTab() {
      this.itemResourcesUsed = [];
      if (this.categories.length <= 0) {
        return;
      }
      this.categories = JSON.parse(JSON.stringify(this.categories));

      this.categories.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category => {
        category.item.filter(item => !item.itemDeleted && item.resourceField && item.resourceField.length > 0).forEach((item) => {
          item.resourceField.filter((resource) => resource && resource.name).forEach((resource) => {
            let realResourceName = this.getOriginNameResource(resource);
            if (resource.itemResourceDeleted) {
              this.removeResourceWasUsed(resource, false);
              return;
            }
            let resourceUsed = this.itemResourcesUsed.some(itemResourceUsed =>
              (itemResourceUsed.name === resource.name || itemResourceUsed.name === realResourceName) && resource.name !== "blank_item");
            if (!resourceUsed) {
              resource.property_category_name = this.getOriginPropertyResource(resource);
              this.itemResourcesUsed.push(resource);
            }
          });
        });
      });

      this.categories.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0 && item.itemDeleted).forEach(item => {
          item.resourceField.filter((resource) => resource && resource.name).forEach(resource => this.removeResourceWasUsed(resource, true));
        });
      });

      this.categories.filter(category => category.item && category.item.length > 0 && category.categoryDeleted).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach((item) => {
          item.resourceField.filter((resource) => resource && resource.name).forEach(resource => this.removeResourceWasUsed(resource, true));
        });
      });
    },

    removeResourceWasUsed(resource, oneResource) {
      let resourceEduOrCareer = this.getOriginNameResource(resource);
      if (oneResource && !this.itemResourcesUsed.some(itemResourceUsed => (itemResourceUsed.name === resource.name || itemResourceUsed.name === resourceEduOrCareer) && ((itemResourceUsed.property_category_name === resource.property_category_name && resource.property_category_name) || !resource.property_category_name))) {
        return;
      }

      let indexOfResourceWasUsed = this.itemResourcesUsed.findIndex(item => (item.name === resource.name || item.name === resourceEduOrCareer) && ((item.property_category_name === resource.property_category_name && resource.property_category_name) || !resource.property_category_name));
      if (indexOfResourceWasUsed >= 0) {
        this.itemResourcesUsed.splice(indexOfResourceWasUsed, 1);
      }
    },

    getOriginNameResource(resource) {
      if (!resource.name.includes("careers.") || !resource.name.includes("educations.")) {
        return "";
      }

      return resource.name.substring(resource.name.indexOf(".") + 1, resource.name.length);
    },

    getOriginPropertyResource(resource) {
      if (resource.name.includes("careers.") || resource.name.includes("educations.")) {
        return resource.name.substring(0, resource.name.indexOf("."));
      }

      return "";
    },

    async getCandidateCategories(hash) {
      await entrySettingService.getCandidateCategories(hash, this.token).then(response => {
            if (response && response.data != null) {
              this.candidateCategories = Object.keys(response.data).map(key => {
                return response.data[key];
              });
            }
          }).catch(e => {
            Utils.responsePageMaintenance(e);
            Vue.$toast.clear();
            Vue.$toast.error(
                entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
                  position: "bottom-right",
                  duration: 3000,
                }
            );
          });
    },

    updatedSelectedTheme(selectedTheme) {
      this.selectedTheme = Number(selectedTheme);
    },

    async getCustomizeTheme(type, hash) {
      await entrySettingService.getCustomizeTheme(type, hash, this.token).then(response => {
            this.customizeSettings = response.data;
            if (this.customizeSettings.length !== 0 && this.selectedTheme === -1) {
              this.selectedTheme = this.customizeSettings[0].id;
            }
          }).catch(e => {
            console.log(e);
          });
    },

    async closeModalPreview() {
      await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click button " + customizeModalLabels.BUTTON_CLOSE_MODAL);
      this.isVisibleModalPreview = false;
      this.updateEditingStatus(false);
    },

    async openModalPreview() {
      this.isLoadingData = true;
      if (this.selectedTheme > 0) {
        this.colors = this.customizeSettings.find(customizeColor => customizeColor && customizeColor.id === this.selectedTheme);
      }

      await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click button " + entrySettingProperty.PREVIEW_BUTTON);
      Promise.all([this.getKeyMasterUsed(), this.getMastersByCategorySetting(this.keyMasters, this.log.hash)]).finally(() => {
        this.isLoadingData = false;
        this.isVisibleModalPreview = true;
      });

      this.updateEditingStatus(true);
    },

    async cancelChangeEntryScreenSettings() {
      this.isLoadingData = true;
      await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click button " + entrySettingProperty.CANCEL_BUTTON);
      this.property = "";
      this.propertySearchInMailTab = "";
      this.propertyJob = "";
      await this.getResourceFields("", this.log.hash);
      await this.getJobResourceFields("", this.log.hash);
      await this.getEntryFormSetting(entryFormType, this.log.hash);
      if (!this.formSetting.id) {
        this.resetDataSetting();
      }

      this.$eventBus.$emit("unSaved", false);
      this.isLoadingData = false;
    },
    resetDataSetting() {
      this.formSetting = {
        formColorTheme: 0,
        categorySetting: [],
        buttonSetting: [],
        messageSetting: [],
        policySetting: [],
        mailSetting: [],
        customizeSetting: {},
      }

      this.categories = [];
      this.button = {
        entryButton: "",
        confirmButton: "",
        returnButton: "",
      }

      this.buttonSettings = [];
      this.message = {
        titleEntry: "",
        titleConfirm: "",
        titleCompletion: "",
        messageTitleCompletion: "",
        messageConfirm: "",
        messageBodyCompletion: "",
        messageError: "",
      };

      this.policy = {
        content: "",
        url: "",
        textLink: "",
        isEnabledPolicy: false,
        isEnabledUrl: false,
      };

      this.mail = {
        emailTitle: "",
        errorEmailTitle: "",
        emailBody: "",
        emailSubject: "",
        userId: 0,
        emailAccounts: [
          {
            emailAccount: "",
          },
        ],
      };

      this.buttonError = false;
      this.selectedTheme = 1;
      this.refreshResourceField();
    },

    handleOutputData() {
      if (!this.buttonError) {
        this.handleOutputButton();
      }

      if (!this.messageError) {
        this.handleOutputMessage();
      }

      if (!this.policyError) {
        this.handleOutputPolicy();
      }

      if (!this.mailError) {
        this.handleOutputMail();
      }

      this.handleOutputColors();
      this.handleOutPutCategory();
      this.handleOutputDisplaySetting();
      this.handleOutputReplaceMailSetting();

      this.formSetting.buttonSetting = this.buttonSettings;
      this.formSetting.messageSetting = this.messageSettings;
      this.formSetting.policySetting = this.policySettings;
      this.formSetting.mailSetting = this.mailSettings;
      this.formSetting.categorySetting = JSON.parse(JSON.stringify(this.categories));
      this.formSetting.displaySetting = this.displaySetting;
      this.formSetting.replaceMailSetting = this.mailReplaces;
      this.formSetting.replaceMailSettingJob = this.mailReplacesJob;
      this.formSetting.replaceMailSettingDispatch = this.mailReplacesDispatch;
    },

    alertMissingKeyReplace(){
      let missingKeyReplaces = this.missingKeyReplaces && this.missingKeyReplaces.length > 0? entrySettingNotificationProperty.MESSAGE_ENTRY_BODY_MAIL_KEY_REPLACE + this.missingKeyReplaces.join(", "): "";
      let missingKeyReplacesJob = this.missingKeyReplacesJob && this.missingKeyReplacesJob.length > 0? entrySettingNotificationProperty.MESSAGE_JOB_BODY_MAIL_KEY_REPLACE + this.missingKeyReplacesJob.join(", "): "";
      let missingKeyReplacesDispatch = this.missingKeyReplacesDispatch && this.missingKeyReplacesDispatch.length > 0? entrySettingNotificationProperty.MESSAGE_DISPATCH_JOB_BODY_MAIL_KEY_REPLACE + this.missingKeyReplacesDispatch.join(", "): "";

      let alertMessage = "";
      if(missingKeyReplaces) alertMessage += missingKeyReplaces;
      if(missingKeyReplacesJob) alertMessage += alertMessage ? "\n" + missingKeyReplacesJob : missingKeyReplacesJob;
      if(missingKeyReplacesDispatch) alertMessage += alertMessage ? "\n" + missingKeyReplacesDispatch: missingKeyReplacesDispatch;

      alert(entrySettingNotificationProperty.NOTIFY_KEY_REPLACE_NOT_MATCH + "\n " + alertMessage);
    },

    async saveData() {
      this.isLoadingData = true;
      if (this.keyReplaceInMailBodyNotMathWithSetting()) {
        this.alertMissingKeyReplace();
        this.isLoadingData = false;
        return;
      }

      if (this.itemRequiredIsNotSetting()) {
        alert(entrySettingNotificationProperty.NOTIFY_ITEM_REQUIRED_NOT_SETTING + "\n " + this.missingItemRequires.join("\n "));
        this.isLoadingData = false;
        return;
      }

      this.handleOutputData();
      this.refreshResourceField();
      this.log.info.paras = this.formSetting;
      await this.createLogger("Menu " + generalLabels.SECOND_TAB + "-Click button " + entrySettingProperty.SAVE_BUTTON);
      delete this.log.info.paras;
      this.propertyJob = "";
      await this.getJobResourceFields("", this.log.hash);

      this.propertySearchInMailTab = "";
      await this.getResourceFields("", this.log.hash);

      await formSettingService.saveEntryForm(this.formSetting, this.log.hash, this.token).then(async(response) => {
        if (!response.data || !response.data.id) {
          return;
        }
        await this.getCustomizeTheme(entryFormType, this.log.hash);
        await this.getEntryFormSetting(entryFormType, this.log.hash);
        this.isChangeColor = false;
        this.$eventBus.$emit("unSaved", false);
        Vue.$toast.clear();
        Vue.$toast.success(entrySettingNotificationProperty.SAVE_SUCCESSFUL, {
          position: "bottom-right",
          duration: 3000,
        });
      }).catch(e => {
        console.log(e);
        if (e.response.data === 'Form has been already updated!') {
          Vue.$toast.error(generalMessages.ERROR_FORM_HAS_BEEN_UPDATED, {
                position: "bottom-right",
                duration: 3000,
              }
          );
        } else {
          Vue.$toast.error(generalMessages.ERROR_SAVE_DATA, {
                position: "bottom-right",
                duration: 3000,
              }
          );
        }
      }).finally(() => {
        this.isLoadingData = false;
      });
      delete this.log.info.paras;
    },

    handleDataEntrySetting(response){
      this.formSetting = response.data;
      this.categories = response.data.categorySetting;
      this.categories.forEach(c => c.isCollapse = false);
      this.buttonSettings = response.data.buttonSetting;
      this.messageSettings = response.data.messageSetting;
      this.policySettings = response.data.policySetting;
      this.mailSettings = response.data.mailSetting;
      this.displaySetting = response.data.displaySetting;
      this.mailReplaces = response.data.replaceMailSetting;
      this.mailReplacesJob = response.data.replaceMailSettingJob;
      this.mailReplacesDispatch = response.data.replaceMailSettingDispatch;

      this.handleInputColor();
      this.handleButtonInputData();
      this.handleMessageInputData();
      this.handlePolicyInputData();
      this.handleMailInputData();
      this.handleReplaceMailInputData();
      this.handleInputDisplaySetting();
      this.refreshResourceField();
      this.refreshItemResourceInMailTab();
      this.refreshItemResourceInMailTabJob();
      this.refreshItemResourceInMailTabDispatch();
    },

    handleInputDisplaySetting(){
      this.displaySetting.inHouseHP = this.displaySetting.inHouseHP ? this.displaySetting.inHouseHP: 0;
      this.displaySetting.progressStep = this.displaySetting.progressStep ? this.displaySetting.progressStep: 0;
      this.displaySetting.print = this.displaySetting.print ? this.displaySetting.print: false;
      this.displaySetting.manager = this.displaySetting.manager ? this.displaySetting.manager: 0;
    },

    keyReplaceInMailBodyNotMathWithSetting() {
      if ((this.mailReplaces.length <= 0 || this.mail.emailBody.length <= 0) && (this.mailReplacesJob.length <= 0 || this.mail.emailBodyJob.length <= 0) && (this.mailReplacesDispatch.length <= 0 || this.mail.emailBodyDispatch.length <= 0)) {
        return false;
      }
      const regex = /{{([\w]+)}}/g;

      this.missingKeyReplaces = [];
      let keyInBodyMails = [];
      if (this.mail.emailBody.match(regex)) {
        keyInBodyMails = this.mail.emailBody.match(regex).filter(key => key && key.length > 4 && key.includes("{{"));
      }

      let keyMailReplaces = [];
      this.mailReplaces.filter(mailReplace => mailReplace && mailReplace.keyReplace).forEach(mailReplace => keyMailReplaces.push(mailReplace.keyReplace));
      keyInBodyMails.forEach(keyInBodyMail => {
        if (!keyMailReplaces.includes(keyInBodyMail)) {
          if (!this.missingKeyReplaces.includes(keyInBodyMail.substring(2, keyInBodyMail.length - 2))) {
            this.missingKeyReplaces.push(keyInBodyMail.substring(2, keyInBodyMail.length - 2));
          }
        }
      });

      this.missingKeyReplacesJob = [];
      keyInBodyMails = [];
      if (this.mail.emailBodyJob.match(regex)) {
        keyInBodyMails = this.mail.emailBodyJob.match(regex).filter(key => key && key.length > 4 && key.includes("{{"));
      }

      keyMailReplaces = [];
      this.mailReplacesJob.filter(mailReplace => mailReplace && mailReplace.keyReplace).forEach(mailReplace => keyMailReplaces.push(mailReplace.keyReplace));
      keyInBodyMails.forEach(keyInBodyMail => {
        if (!keyMailReplaces.includes(keyInBodyMail)) {
          if (!this.missingKeyReplacesJob.includes(keyInBodyMail.substring(2, keyInBodyMail.length - 2))) {
            this.missingKeyReplacesJob.push(keyInBodyMail.substring(2, keyInBodyMail.length - 2));
          }
        }
      });

      this.missingKeyReplacesDispatch = [];
      keyInBodyMails = [];
      if (this.mail.emailBodyDispatch.match(regex)) {
        keyInBodyMails = this.mail.emailBodyDispatch.match(regex).filter(key => key && key.length > 4 && key.includes("{{"));
      }

      keyMailReplaces = [];
      this.mailReplacesDispatch.filter(mailReplace => mailReplace && mailReplace.keyReplace).forEach(mailReplace => keyMailReplaces.push(mailReplace.keyReplace));
      keyInBodyMails.forEach(keyInBodyMail => {
        if (!keyMailReplaces.includes(keyInBodyMail)) {
          if (!this.missingKeyReplacesDispatch.includes(keyInBodyMail.substring(2, keyInBodyMail.length - 2))) {
            this.missingKeyReplacesDispatch.push(keyInBodyMail.substring(2, keyInBodyMail.length - 2));
          }
        }
      });

      return this.missingKeyReplaces.length > 0 || this.missingKeyReplacesJob.length > 0 || this.missingKeyReplacesDispatch.length > 0;
    },

    itemRequiredIsNotSetting() {
      if (this.resourceFields.length === 0 || this.candidateCategories.length === 0) {
        return false;
      }
      let resourceFields = JSON.parse(JSON.stringify(this.resourceFields));

      this.missingItemRequires = [];
      this.candidateCategories.forEach((candidateCategory) =>
          resourceFields.filter(resource => resource.display_name && resource.required === 1 && !resource.isUsed).forEach(resource => {
            if (resource.property_category_name === candidateCategory.name && candidateCategory.is_display === 1) {
              this.missingItemRequires.push(resource.display_name);
            }
          })
      );

      return this.missingItemRequires.length > 0;
    },

    handleOutputReplaceMailSetting() {
      if (this.mailReplaces.length !== 0) {
        this.mailReplaces = this.mailReplaces.filter(mail => mail.itemReplaces && mail.itemReplaces.length > 0);
        this.mailReplaces.forEach(mail => {
          mail.itemReplaces.forEach(item => {
            mail.itemReplace = entrySettingProperty.ITEM_ENTRY_MODIFY + item.name;
          });
        });
      }

      if (this.mailReplacesJob.length !== 0) {
        this.mailReplacesJob = this.mailReplacesJob.filter(mail => mail.itemReplaces && mail.itemReplaces.length > 0);
        this.mailReplacesJob.forEach(mail => {
          mail.itemReplaces.forEach(item => {
            let resourcePrefix = "";
            switch (item.resourceType) {
              case ITEM_ENTRY:
                resourcePrefix = entrySettingProperty.ITEM_ENTRY_MODIFY;
                break;
              case ITEM_JOB:
                resourcePrefix = entrySettingProperty.ITEM_JOB_MODIFY;
                break;
            }

            mail.itemReplace = resourcePrefix + item.name;
          });
        });
      }

      if (this.mailReplacesDispatch.length !== 0) {
        this.mailReplacesDispatch = this.mailReplacesDispatch.filter(mail => mail.itemReplaces && mail.itemReplaces.length > 0);
        this.mailReplacesDispatch.forEach(mail => {
          mail.itemReplaces.forEach(item => {
            let resourcePrefix = "";
            switch (item.resourceType) {
              case ITEM_ENTRY:
                resourcePrefix = entrySettingProperty.ITEM_ENTRY_MODIFY;
                break;
              case ITEM_DISPATCH_JOB:
                resourcePrefix = entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY;
                break;
            }

            mail.itemReplace = resourcePrefix + item.name;
          });
        });
      }
    },

    handleOutputDisplaySetting() {
      if (this.displaySetting.progressStep && this.displaySetting.progressStep.id) {
        this.displaySetting.progressStep = this.displaySetting.progressStep.id;
      }

      if (this.displaySetting.inHouseHP && this.displaySetting.inHouseHP.id) {
        this.displaySetting.inHouseHP = this.displaySetting.inHouseHP.id;
      }

      if (this.displaySetting.print && this.displaySetting.print.id) {
        this.displaySetting.print = this.displaySetting.print.id;
      }

      if (this.displaySetting.manager && this.displaySetting.manager.id) {
        this.displaySetting.manager = this.displaySetting.manager.id;
      }

      // this.displaySetting.manager = process.env.VUE_APP_HP_USER_ID;
    },

    handleOutPutCategory() {
      if (this.categories.length <= 0) {
        return;
      }

      this.categories.filter(category => category.item && category.item.length > 0).forEach(category =>
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item =>
              item.resourceField.forEach(resource => {
                delete resource.default_value;
                if (resource.display_name && resource.display_name.length > 255) {
                  resource.display_name = resource.display_name.substring(0, 255);
                }
              })
          )
      );
    },

    handleOutputColors() {
      if (this.isChangeColor) {
        this.formSetting.customizeSetting = this.colors;
      } else {
        if (this.selectedTheme === -1) {
          this.formSetting.customizeSetting = this.colors;
        } else {
          const index = this.customizeSettings.findIndex(item => item.id === this.selectedTheme
          );
          if (index === -1) {
            this.formSetting.customizeSetting = this.colors;
          } else {
            this.formSetting.customizeSetting = this.customizeSettings[index];
          }
        }
      }
    },

    handleOutputButton() {
      const entryBtnIndex = this.buttonSettings.findIndex(btn => btn.buttonType === 0);
      if (entryBtnIndex === -1) {
        this.buttonSettings.push({
          buttonName: this.button.entryButton,
          buttonType: 0
        });
      } else {
        this.buttonSettings[entryBtnIndex].buttonName = this.button.entryButton;
      }

      const confirmBtnIndex = this.buttonSettings.findIndex(btn => btn.buttonType === 1);
      if (confirmBtnIndex === -1) {
        this.buttonSettings.push({
          buttonName: this.button.confirmButton,
          buttonType: 1
        });
      } else {
        this.buttonSettings[confirmBtnIndex].buttonName = this.button.confirmButton;
      }

      const returnBtnIndex = this.buttonSettings.findIndex(btn => btn.buttonType === 2);
      if (returnBtnIndex === -1) {
        this.buttonSettings.push({
          buttonName: this.button.returnButton,
          buttonType: 2
        });
      } else {
        this.buttonSettings[returnBtnIndex].buttonName = this.button.returnButton;
      }
    },

    handleOutputMessage() {
      const entryIndex = this.messageSettings.findIndex(msg => msg.wordingType === 0);
      if (entryIndex === -1) {
        this.messageSettings.push({
          stepTitle: this.message.titleEntry,
          wordingType: 0
        });
      } else {
        this.messageSettings[entryIndex].stepTitle = this.message.titleEntry;
      }

      const confirmIndex = this.messageSettings.findIndex(msg => msg.wordingType === 1);
      if (confirmIndex === -1) {
        this.messageSettings.push({
          stepTitle: this.message.titleConfirm,
          message: this.message.messageConfirm,
          wordingType: 1
        });
      } else {
        this.messageSettings[confirmIndex].stepTitle = this.message.titleConfirm;
        this.messageSettings[confirmIndex].message = this.message.messageConfirm;
      }

      const completionIndex = this.messageSettings.findIndex(msg => msg.wordingType === 2);
      if (completionIndex === -1) {
        this.messageSettings.push({
          stepTitle: this.message.titleCompletion,
          messageTitle: this.message.messageTitleCompletion,
          message: this.message.messageBodyCompletion,
          wordingType: 2
        });
      } else {
        this.messageSettings[completionIndex].stepTitle = this.message.titleCompletion;
        this.messageSettings[completionIndex].messageTitle = this.message.messageTitleCompletion;
        this.messageSettings[completionIndex].message = this.message.messageBodyCompletion;
      }

      const errorIndex = this.messageSettings.findIndex(msg => msg.wordingType === 3);
      if (errorIndex === -1) {
        this.messageSettings.push({
          message: this.message.messageError,
          wordingType: 3
        });
      } else {
        this.messageSettings[errorIndex].message = this.message.messageError;
      }
    },

    handleOutputPolicy() {
      const policyIndex = this.policySettings.findIndex(policy => policy.privacyPolicyType === 0);
      if (policyIndex === -1) {
        this.policySettings.push({
          privacyPolicy: this.policy.content,
          enable: this.policy.isEnabledPolicy,
          privacyPolicyType: 0
        });
      } else {
        this.policySettings[policyIndex].privacyPolicy = this.policy.content;
        this.policySettings[policyIndex].enable = this.policy.isEnabledPolicy;
      }

      const urlIndex = this.policySettings.findIndex(policy => policy.privacyPolicyType === 1);
      if (urlIndex === -1) {
        this.policySettings.push({
          urlLink: this.policy.url,
          link: this.policy.textLink,
          enable: this.policy.isEnabledUrl,
          privacyPolicyType: 1
        });
      } else {
        this.policySettings[urlIndex].link = this.policy.textLink;
        this.policySettings[urlIndex].urlLink = this.policy.url;
        this.policySettings[urlIndex].enable = this.policy.isEnabledUrl;
      }
    },

    handleOutputMail() {
      const autoMailIndex = this.mailSettings.findIndex(mail => mail.emailType === AUTO_MAIL_REPLY);
      if (autoMailIndex === -1) {
        this.mailSettings.push({
          emailTitle: this.mail.emailTitle,
          emailBody: this.mail.emailBody,
          emailAccounts: [
            {
              isUserDeleted: this.mail.user.isDeleted,
              emailAccount: this.mail.user.email,
              userId: this.mail.user.id && this.mail.user.id >= 0 ? this.mail.user.id : null
            }
          ],
          emailType: AUTO_MAIL_REPLY
        });
      } else {
        this.mailSettings[autoMailIndex].emailTitle = this.mail.emailTitle;
        this.mailSettings[autoMailIndex].emailBody = this.mail.emailBody;
        this.mailSettings[autoMailIndex].emailAccounts[0] = {};
        this.mailSettings[autoMailIndex].emailAccounts[0].userId = this.mail.user.id;
        this.mailSettings[autoMailIndex].emailAccounts[0].emailAccount = this.mail.user.email;
        this.mailSettings[autoMailIndex].emailAccounts[0].isUserDeleted = this.mail.user.isDeleted;
      }

      const autoMailJobIndex = this.mailSettings.findIndex(mail => mail.emailType === AUTO_MAIL_REPLY_JOB);
      if (autoMailJobIndex === -1) {
        this.mailSettings.push({
          emailBody: this.mail.emailBodyJob,
          emailType: AUTO_MAIL_REPLY_JOB
        });
      } else {
        this.mailSettings[autoMailJobIndex].emailBody = this.mail.emailBodyJob;
      }

      const autoMailDispatchIndex = this.mailSettings.findIndex(mail => mail.emailType === AUTO_MAIL_REPLY_DISPATCH);
      if (autoMailDispatchIndex === -1) {
        this.mailSettings.push({
          emailBody: this.mail.emailBodyDispatch,
          emailType: AUTO_MAIL_REPLY_DISPATCH
        });
      } else {
        this.mailSettings[autoMailDispatchIndex].emailBody = this.mail.emailBodyDispatch;
      }

      const accountMailIndex = this.mailSettings.findIndex(mail => mail.emailType === NOTIFICATION_MAIL);
      if (accountMailIndex === -1) {
        let accountMail = {
          emailTitle: this.mail.emailSubject,
          errorEmailTitle: this.mail.errorEmailTitle,
          emailAccounts: [],
          emailType: NOTIFICATION_MAIL
        };

        this.mail.emailAccounts.forEach(account =>
            accountMail.emailAccounts.push({
              emailAccount: account.emailAccount
            })
        );

        this.mailSettings.push(accountMail);
      } else {
        this.mailSettings[accountMailIndex].emailTitle = this.mail.emailSubject;
        this.mailSettings[accountMailIndex].errorEmailTitle = this.mail.errorEmailTitle;
        this.mailSettings[accountMailIndex].emailAccounts = [];
        this.mail.emailAccounts.forEach((account) => this.mailSettings[accountMailIndex].emailAccounts.push(account));
      }
    },

    validateFormatEmail(email) {
      return !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
    },

    updateCategory(categories) {
      this.categories = JSON.parse(JSON.stringify(categories));
    },

    async getEntryFormSetting(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response.data || !response.data.id) {
          return;
        }
        this.handleDataEntrySetting(response, hash);
        this.checkItemDeletedFromMainSystem(hash);
        this.$eventBus.$emit("unSaved", false);
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        this.$eventBus.$emit("unSaved", false);
      });
    },

    async getDetailFormData(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response || !response.data || !response.data.id || !response.data.categorySetting) {
          return;
        }

        this.jobDetailForm = response.data.categorySetting;
      }).catch(e => {
        console.log(e);
      });
    },

    async getDispatchDetailFormData(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response || !response.data || !response.data.id || !response.data.categorySetting) {
          return;
        }

        this.dispatchJobDetailForm = response.data.categorySetting;
      }).catch(e => {
        console.log(e);
      });
    },

    async handleReplaceMailInputData() {
      if (!this.mailReplaces || this.mailReplaces.length <= 0 || this.resourceFields.length <= 0) {
        this.resetMailReplace(entryFormType);
      } else {
        this.mailReplaces.filter((mail) => mail && mail.itemReplace).forEach(mail => {
          if (!mail.itemReplaces) {
            mail.itemReplaces = [];
          }

          if (!mail.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY) && !mail.itemReplace.startsWith(entrySettingProperty.ITEM_JOB_MODIFY) && !mail.itemReplace.startsWith(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY)) {
            mail.itemReplace = entrySettingProperty.ITEM_ENTRY_MODIFY + mail.itemReplace;
          }

          let resourceFieldUsed = this.resourceFields.filter(humanResource => humanResource && humanResource.name === mail.itemReplace.substring(entrySettingProperty.ITEM_ENTRY_MODIFY.length, mail.itemReplace.length));
          if (resourceFieldUsed.length > 0) {
            resourceFieldUsed[0].resourceType = ITEM_ENTRY;
            mail.itemReplaces.push(resourceFieldUsed[0]);
          }
        });
      }

      if (!this.mailReplacesJob || this.mailReplacesJob.length <= 0 || this.resourceFields.length <= 0 || this.jobResourceFields.length <= 0) {
        this.resetMailReplace(JOB_DETAIL_FORM_TYPE);
      } else {
        this.mailReplacesJob.filter(mail => mail && mail.itemReplace).forEach(mail => {
          if (!mail.itemReplaces) {
            mail.itemReplaces = [];
          }

          if (!mail.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY) && !mail.itemReplace.startsWith(entrySettingProperty.ITEM_JOB_MODIFY) && !mail.itemReplace.startsWith(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY)) {
            mail.itemReplace = entrySettingProperty.ITEM_ENTRY_MODIFY + mail.itemReplace;
          }

          let resourceFieldUsed = this.resourceFields.filter(humanResource => humanResource && mail.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY) && humanResource.name === mail.itemReplace.substring(entrySettingProperty.ITEM_ENTRY_MODIFY.length, mail.itemReplace.length));
          if (resourceFieldUsed.length > 0) {
            resourceFieldUsed[0].resourceType = ITEM_ENTRY;
            mail.itemReplaces.push(resourceFieldUsed[0]);
          }

          resourceFieldUsed = this.jobResourceFields.filter(jobResource => jobResource && mail.itemReplace.startsWith(entrySettingProperty.ITEM_JOB_MODIFY) && jobResource.name === mail.itemReplace.substring(entrySettingProperty.ITEM_JOB_MODIFY.length, mail.itemReplace.length));
          if (resourceFieldUsed.length > 0) {
            resourceFieldUsed[0].resourceType = ITEM_JOB;
            mail.itemReplaces.push(resourceFieldUsed[0]);
          }
        });
      }

      if (!this.mailReplacesDispatch || this.mailReplacesDispatch.length <= 0 || this.resourceFields.length <= 0 || this.dispatchJobResourceFields.length <= 0) {
        this.resetMailReplace(DISPATCH_JOB_DETAIL_FORM_TYPE);
      } else {
        this.mailReplacesDispatch.filter(mail => mail && mail.itemReplace).forEach(mail => {
          if (!mail.itemReplaces) {
            mail.itemReplaces = [];
          }

          if (!mail.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY) && !mail.itemReplace.startsWith(entrySettingProperty.ITEM_JOB_MODIFY) && !mail.itemReplace.startsWith(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY)) {
            mail.itemReplace = entrySettingProperty.ITEM_ENTRY_MODIFY + mail.itemReplace;
          }

          let resourceFieldUsed = this.resourceFields.filter(humanResource => humanResource && mail.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY) && humanResource.name === mail.itemReplace.substring(entrySettingProperty.ITEM_ENTRY_MODIFY.length, mail.itemReplace.length));
          if (resourceFieldUsed.length > 0) {
            resourceFieldUsed[0].resourceType = ITEM_ENTRY;
            mail.itemReplaces.push(resourceFieldUsed[0]);
          }

          resourceFieldUsed = this.dispatchJobResourceFields.filter(jobResource => jobResource && mail.itemReplace.startsWith(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY) && jobResource.name === mail.itemReplace.substring(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY.length, mail.itemReplace.length));
          if (resourceFieldUsed.length > 0) {
            resourceFieldUsed[0].resourceType = ITEM_DISPATCH_JOB;
            mail.itemReplaces.push(resourceFieldUsed[0]);
          }
        });
      }

      this.updatedReplaceMail(JSON.parse(JSON.stringify(this.mailReplaces)));
      this.updatedReplaceMailJob(JSON.parse(JSON.stringify(this.mailReplacesJob)));
      this.updatedReplaceMailDispatch(JSON.parse(JSON.stringify(this.mailReplacesDispatch)));
    },

    resetMailReplace(type) {
      switch (type) {
        case entryFormType:
          this.mailReplaces = [
            {
              keyReplace: "",
              itemReplace: "",
              itemReplaces: [],
            },
          ];
          break;
        case JOB_DETAIL_FORM_TYPE:
          this.mailReplacesJob = [
            {
              keyReplace: "",
              itemReplace: "",
              itemReplaces: [],
            },
          ];
          break;
        case DISPATCH_JOB_DETAIL_FORM_TYPE:
          this.mailReplacesDispatch = [
            {
              keyReplace: "",
              itemReplace: "",
              itemReplaces: [],
            },
          ];
          break;
      }
    },

    handleInputColor() {
      this.selectedTheme = this.formSetting.formColorTheme;
      const index = this.customizeSettings.findIndex(item => item.id === this.selectedTheme);
      if (index === -1) {
        this.selectedTheme = this.customizeSettings[0].id;
        this.colors.themeName = this.customizeSettings[0].themeName;
      } else {
        this.colors.themeName = this.customizeSettings[index].themeName;
        this.colors = this.customizeSettings[index];
      }
    },

    handleCategoryInputData() {
      for (let i = 0; i < this.categories.length; i++) {
        this.categories[i].categoryDisplay = i;
      }
    },

    handleButtonInputData() {
      this.buttonSettings.forEach((btn) => {
        switch (btn.buttonType) {
          case 0:
            this.button.entryButton = btn.buttonName;
            break;
          case 1:
            this.button.confirmButton = btn.buttonName;
            break;
          case 2:
            this.button.returnButton = btn.buttonName;
            break;
        }
      });
    },

    handleMessageInputData() {
      this.messageSettings.forEach((msg) => {
        switch (msg.wordingType) {
          case 0:
            this.message.titleEntry = msg.stepTitle;
            break;
          case 1:
            this.message.titleConfirm = msg.stepTitle;
            this.message.messageConfirm = msg.message;
            break;
          case 2:
            this.message.titleCompletion = msg.stepTitle;
            this.message.messageTitleCompletion = msg.messageTitle;
            this.message.messageBodyCompletion = msg.message;
            break;
          case 3:
            this.message.messageError = msg.message;
            break;
        }
      });
    },

    handlePolicyInputData() {
      this.policySettings.forEach((policy) => {
        switch (policy.privacyPolicyType) {
          case 0:
            this.policy.content = policy.privacyPolicy;
            this.policy.isEnabledPolicy = policy.enable;
            break;
          case 1:
            this.policy.url = policy.urlLink;
            this.policy.textLink = policy.link;
            this.policy.isEnabledUrl = policy.enable;
            break;
        }
      });
    },

    handleMailInputData() {
      if (this.mailSettings.length <= 0) {
        return;
      }

      let emails = [];
      this.mailSettings.forEach((mail) => {
        switch (mail.emailType) {
          case AUTO_MAIL_REPLY:
            this.mail.emailTitle = mail.emailTitle;
            this.mail.emailBody = mail.emailBody;
            this.mail.user = {
              id: 0,
              email: "",
              isDeleted: false
            };
            emails = mail.emailAccounts;
            if (emails && emails.length > 0) {
              this.mail.user.id = emails[0].userId ? emails[0].userId : null;
              this.mail.user.email = emails[0].emailAccount ? emails[0].emailAccount : "";
              this.mail.user.isDeleted = emails[0].deletedDate ? true : false;
            }

            break;
          case AUTO_MAIL_REPLY_JOB:
            this.mail.emailBodyJob = mail.emailBody;
            break;
          case AUTO_MAIL_REPLY_DISPATCH:
            this.mail.emailBodyDispatch = mail.emailBody;
            break;
          case NOTIFICATION_MAIL:
            this.mail.emailSubject = mail.emailTitle;
            this.mail.errorEmailTitle = mail.errorEmailTitle;
            if (mail.emailAccounts.length === 0) {
              this.mail.emailAccounts = [
                {
                  emailAccount: ""
                },
              ];
            } else {
              this.mail.emailAccounts = [];
              mail.emailAccounts.forEach(account => this.mail.emailAccounts.push(account));
            }

            break;
        }
      });
    },

    updateColors(colors, isChange) {
      if (isChange) {
        this.isChangeColor = isChange;
      }

      this.colors = JSON.parse(JSON.stringify(colors));
    },

    updateBtnError(btnError) {
      this.buttonError = btnError;
    },

    updateMsgError(msgError) {
      this.messageError = msgError;
    },

    updatePolicyError(policyError) {
      this.policyError = policyError;
    },

    updateMailError(mailError) {
      this.mailError = mailError;
    },

    async checkItemDeletedFromMainSystem(hash) {
      await this.getResourceFields("", hash);
      if(!this.resourceFields || this.resourceFields.length <= 0 || this.categories.length <= 0){
        return;
      }
      this.itemsDeletedMainSystem = [];
      this.categories.filter(category => category.item && category.item.length > 0).forEach(category =>
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item =>
              item.resourceField.forEach(resourceUsed => {
                if (resourceUsed.name && (resourceUsed.name.includes("careers.") || resourceUsed.name.includes("educations."))) {
                  let nameResourceEducationOrCareer = resourceUsed.name.substring(resourceUsed.name.indexOf(".") + 1, resourceUsed.name.length);
                  let indexResourceEducationOrCareer = this.resourceFields.findIndex(resourceMain => resourceMain.name === nameResourceEducationOrCareer);
                  if (indexResourceEducationOrCareer >= 0) {
                    return;
                  }
                } else {
                  let indexResourceUse = this.resourceFields.findIndex(resourceMain => resourceMain.name === resourceUsed.name);
                  if (indexResourceUse >= 0 || (resourceUsed.name && resourceUsed.name.includes("blank_item"))) {
                    return;
                  }
                }

                item.isDeletedByMainSystem = true;
                resourceUsed.isResourceDeletedByMainSystem = true;
                if (!this.itemsDeletedMainSystem.includes(resourceUsed.display_name)) {
                  this.itemsDeletedMainSystem.push(resourceUsed.display_name);
                  this.idItemsDeletedMainSystems.push(resourceUsed.id);
                }
              })
          )
      );

      if (this.itemsDeletedMainSystem.length > 0) {
        alert(entrySettingNotificationProperty.NOTIFY_ITEM_DELETED + "\n " + this.itemsDeletedMainSystem.join("\n"));
      }

      if (this.idItemsDeletedMainSystems.length > 0) {
        await formSettingService.updateTimeItemDeleted(this.idItemsDeletedMainSystems, hash, this.token).catch(e => {
          console.log(e);
        });
      }
    },

    async refreshCustomizeSettings(hash) {
      await this.getCustomizeTheme(entryFormType, hash);
      const indexOfThemeSetting = this.customizeSettings.findIndex(customizeSetting => customizeSetting.id === this.formSetting.formColorTheme);
      if(indexOfThemeSetting === -1){
        this.selectedTheme = this.customizeSettings[0].id;
        this.$eventBus.$emit("unSaved", true);
      }else{
        this.selectedTheme = this.formSetting.formColorTheme;
        this.$eventBus.$emit("unSaved", false);
      }
    },

    async refreshResourceList(hash) {
      this.isLoadingData = true;
      await entrySettingService.deleteRedisData(hash, this.token).then(() => {
        Promise.all([this.getCandidateCategories(hash), this.getResourceFields("", hash)]).then(() => {
          this.refreshItemSetting();
        }).finally(() => {
          this.isLoadingData = false;
        });
      }).catch(e => {
        console.log(e);
        Vue.$toast.clear();
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    async refreshResourceListInMailTab(hash) {
      this.isLoadingData = true;
      await entrySettingService.deleteRedisData(hash, this.token).then(() => {
        Promise.all([this.getCandidateCategories(hash), this.getResourceFields("", hash)]).finally(() => {
          this.isLoadingData = false;
        });
      }).catch(e => {
        this.isLoadingData = false;
        console.log(e);
        Vue.$toast.clear();
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    refreshItemSetting() {
      this.categories.forEach(category => category.item.forEach(item => item.resourceField.forEach(resource => {
        let propertyResource = this.getOriginPropertyResource(resource);
        let existResource = this.resourceFields.find(resourceSetting => resource.name === resourceSetting.name && ((propertyResource && propertyResource === resourceSetting.property_category_name) || !propertyResource));
        if(existResource) {
          resource.unit = existResource.unit;
          resource.min_length = existResource.min_length;
          resource.default_value = existResource.default_value;
          resource.step = existResource.step;
          resource.display_name = existResource.display_name;
          resource.type = existResource.type;
          resource.is_free_item = existResource.is_free_item;
          resource.required = existResource.required;
          if (!item.itemRequired && existResource.required) item.itemRequired = true;
          resource.master_name = existResource.master_name;
          resource.max_length = existResource.max_length;
          resource.free_master_group_id = existResource.free_master_group_id;
        }
      })));

      this.saveData();
    },

    async refreshJobResourceList(hash) {
      this.isLoadingData = true;
      Vue.$toast.clear();
      await jobSettingService.deleteRedisData(hash, this.token).then(() => {
        Promise.all([this.getJobResourceFields("", hash), this.getJobCategories(hash)]).finally(() => {
          this.isLoadingData = false;
        })
      }).catch(e => {
        console.log(e);
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    async getJobResourceFields(property, hash) {
      property = StrUtil.toHalfWidth(property);
      let searchDto = {};
      searchDto.keyWord = property;
      await jobSettingService.getJobResourceField(searchDto, hash).then(response => {
        if (response && response.data != null) {
          this.jobResourceFields = Object.keys(response.data).map(key => {
            return response.data[key];
          });

          this.refreshJobResourceField();
          this.refreshItemResourceInMailTab();
          this.refreshItemResourceInMailTabJob();
          this.refreshItemResourceInMailTabDispatch();
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        Vue.$toast.clear();
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    refreshJobResourceField() {
      if (this.jobDetailForm.length === 0) {
        return;
      }

      this.jobDetailForm.forEach(category =>{
        category.item.filter(item => item.resourceField && !item.itemDeleted && item.resourceField.length > 0).forEach(item =>{
          item.resourceField.filter(resource => resource && !resource.itemResourceDeleted && resource.name).forEach(resource =>
            this.jobResourceFields.filter(itemJob => itemJob.name === resource.name).forEach(itemJob => itemJob.isUsed = true)
          )
        });
      });
    },

    async getJobCategories(hash) {
      await jobSettingService.getJobCategories(hash, this.token).then(response => {
        if (response && response.data != null) {
          this.jobCategories = Object.keys(response.data).map(key => {
            return response.data[key];
          });
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        Vue.$toast.clear();
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    async refreshDispatchJobResourceList(hash) {
      this.isLoadingData = true;
      Vue.$toast.clear();
      await jobSettingService.deleteDispatchRedisData(hash, this.token).then(() => {
        Promise.all([this.getDispatchJobResourceFields("", hash), this.getDispatchJobCategories(hash)]).finally(() => {
          this.isLoadingData = false;
        })
      }).catch(e => {
        console.log(e);
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    async getDispatchJobResourceFields(property, hash) {
      property = StrUtil.toHalfWidth(property);
      let searchDto = {};
      searchDto.keyWord = property;
      await jobSettingService.getDispatchJobResourceField(searchDto, hash).then(response => {
        if (response && response.data != null) {
          this.dispatchJobResourceFields = [];
          Object.keys(response.data).map(key => {
            if (response.data[key].property_category_name === undefined) {
              Object.keys(response.data[key]).map(subKey => {
                let subResource = response.data[key][subKey];
                subResource.name = key + "." + subResource.name;
                this.dispatchJobResourceFields.push(subResource);
              });
            } else {
              this.dispatchJobResourceFields.push(response.data[key]);
            }
          });

          this.refreshDispatchJobResourceField();
          this.refreshItemResourceInMailTab();
          this.refreshItemResourceInMailTabJob();
          this.refreshItemResourceInMailTabDispatch();
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        Vue.$toast.clear();
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    refreshDispatchJobResourceField() {
      if (this.dispatchJobDetailForm.length === 0) {
        return;
      }

      this.dispatchJobDetailForm.forEach(category => {
        category.item.filter(item => item.resourceField && !item.itemDeleted && item.resourceField.length > 0).forEach(item =>{
          item.resourceField.filter(resource => resource && !resource.itemResourceDeleted && resource.name).forEach(resource =>
              this.dispatchJobResourceFields.filter(itemJob => itemJob.name === resource.name).forEach(itemJob => itemJob.isUsed = true)
          )
        });
      });
    },

    async getDispatchJobCategories(hash) {
      await jobSettingService.getDispatchJobCategories(hash, this.token).then(response => {
        if (response && response.data != null) {
          this.dispatchJobCategories = Object.keys(response.data).map(key => {
            return response.data[key];
          });
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        Vue.$toast.clear();
        Vue.$toast.error(
            entrySettingNotificationProperty.NOTIFY_FAIL_GET_RESOURCE, {
              position: "bottom-right",
              duration: 3000,
            }
        );
      });
    },

    scrollMenuItem() {
      let scroll = document.getElementById("entry-main-content");
      let startScrollScreenTab = document.getElementById("menu-search-item-screen-tab");
      let startScrollMailTab = document.getElementById("menu-search-item-mail-tab");
      if (!startScrollScreenTab || !scroll || !startScrollMailTab) {
        return;
      }
      let heightOfTop = window.innerHeight;
      if (scroll.scrollTop > 105) {
        heightOfTop = heightOfTop - 24;
        startScrollScreenTab.style.top = scroll.scrollTop - 105 + "px";
        startScrollMailTab.style.top = scroll.scrollTop - 105 + "px";
      } else {
        startScrollScreenTab.style.top = "0px";
        startScrollMailTab.style.top = "0px";
      }
      this.resizeHeightMenuSearch(heightOfTop);
      this.resizeHeightMenuItemSettingMail(heightOfTop);
    },

    resizeHeightMenuItemSettingMail(heightOfTop){
      let elementEntryHeadingSearch = document.getElementById("entry_heading_search_item_mail");
      if(!elementEntryHeadingSearch){
        return;
      }
      let elementFooter = document.getElementById("setting_footer").getBoundingClientRect();
      let elementHideItemEntry = document.getElementById("entry_item_resource_wrap_mail");
      let elementHideItemJob = document.getElementById("job_item_resource_wrap_mail");
      let elementHideItemDispatchJob = document.getElementById("dispatch_job_item_resource_wrap_mail");

      if(!elementHideItemEntry || !elementFooter){
        return;
      }
      let numberOfMenu = 1;
      numberOfMenu = elementHideItemJob ? numberOfMenu +=1 : numberOfMenu;
      numberOfMenu = elementHideItemDispatchJob ? numberOfMenu +=1 : numberOfMenu;

      let isDisplayDispatchJob = elementHideItemDispatchJob ? elementHideItemDispatchJob.style.display : "";
      let isDisplayJob = elementHideItemJob ? elementHideItemJob.style.display : "";
      let isDisplayEntry = elementHideItemEntry.style.display;
      let boundEntryHeadingSearch = elementEntryHeadingSearch.getBoundingClientRect();
      let headingMenuSearch = boundEntryHeadingSearch.height ? boundEntryHeadingSearch.height: 86;
      let heightFinal = heightOfTop - (boundEntryHeadingSearch.y + 2*headingMenuSearch + 2*elementFooter.height);
      let heightOfMenu = 0;
      if(numberOfMenu === 1){
        heightFinal = heightOfTop - (boundEntryHeadingSearch.y + headingMenuSearch + elementFooter.height);
      }
      let countViewWrap = 0;
      countViewWrap = isDisplayEntry === 'block' ? countViewWrap+= 1: countViewWrap;
      countViewWrap = isDisplayJob === 'block' ? countViewWrap+= 1: countViewWrap;
      countViewWrap = isDisplayDispatchJob === 'block' ? countViewWrap+= 1: countViewWrap;
      if(numberOfMenu === 2){
        heightOfMenu = (heightOfTop - 2*elementFooter.height)/2 - headingMenuSearch - 5;

        if(countViewWrap === 1){
          heightFinal = heightOfMenu + 2*headingMenuSearch + 25;
        }
        if(countViewWrap === 2){
          heightFinal = heightOfMenu;
        }
      }

      if(numberOfMenu === 3){
        if(countViewWrap === 2){
          heightFinal = (heightOfTop - 2*elementFooter.height - 3*headingMenuSearch)/2;
        }
        if(countViewWrap === 3){
          heightFinal = (heightOfTop - 2*elementFooter.height - 3*headingMenuSearch)/3;
        }
      }
      if(elementHideItemDispatchJob){
        elementHideItemDispatchJob.setAttribute("style","display: " + isDisplayDispatchJob + ";height: "+ (heightFinal - 5) + "px !important");
      }
      if(elementHideItemJob){
        elementHideItemJob.setAttribute("style","display: " + isDisplayJob + ";height: "+ heightFinal + "px !important");
      }
      elementHideItemEntry.setAttribute("style", "display: " + isDisplayEntry + ";height: "+ heightFinal + "px !important");
    },

    resizeHeightMenuSearch(heightOfTop){
      let windowInnerHeight = heightOfTop;
      let elementResetHeight = document.getElementById("item_resource_wrapper");
      let elementHeadingSearch = document.getElementById("heading_search_item").getBoundingClientRect();
      let elementFooter = document.getElementById("setting_footer").getBoundingClientRect();
      if(!elementHeadingSearch || !elementFooter || !elementResetHeight){
        return;
      }
      elementResetHeight.style.height = (windowInnerHeight - (elementHeadingSearch.y + elementHeadingSearch.height + elementFooter.height)) +"px";
    },

    async sendLogger(loggerData) {
      this.logs = loggerData;
      await generalService.sendLogger(this.logs.hash, this.logs.info.path, this.logs).then(response => {
        if (response.status === 200) {
          return true;
        }
      }).catch(e => {
        console.log(e);
      });
    },

    async createLogger(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.sendLogger(this.log);
    },

    updateEditingStatus(status) {
      this.editingStatus = status;
    }
  },
};
</script>
<style lang="css" scoped>
.setting_heading{
  height: 28.8px;
}
</style>
